export const PREFIX = "ns-";
import { log } from "../utils/server-log";

const isServerRender = () => typeof localStorage == "undefined";

export const getPersisted = (lsKey) => {
    try {
        if (isServerRender()) return;
        const stored = localStorage.getItem(lsKey);
        if (!stored) return;
        const parsedCart = JSON.parse(stored);
        if (parsedCart && Array.isArray(parsedCart.products)) {
            return parsedCart;
        }
    } catch (e) {
        log("Could not parse stored cart", e.message);
    }
    return null;
};

export const persist = (lsKey, val) => {
    try {
        if (isServerRender()) return;
        const toPersist = JSON.stringify(val);
        localStorage.setItem(lsKey, toPersist);
    } catch (e) {
        log(`persist ${lsKey} failed`, e.message);
    }
};
